module.exports = __webpack_public_path__ + "img/kefu5.6d017e4a.png";